import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import moment from 'moment';
import { environment } from '../../../environments/environment';
import { ReplaySubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromLookups from '../../lookups';
import * as fromShared from '../../shared';
import { IStatusMessage, ResponseStatus, uniqBy } from '../../shared';
import { SelectItem, Table } from '../../shared/efaact-primeng.module';
import { DisplayErrors, IShowErrors } from '../../shared/errors-sidenav';
import { UnsavedChangesService } from '../../shared/modal-dialog';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { IUserInfo } from '../../user-info';
import { IChargeNumberManagement } from '../IChargeNumberManagement';
import { IContractManagement } from '../IContractManagement';
import { IFundingMod } from '../IFundingMod';
import { IInvoiceCycle } from '../IInvoiceCycle';

@Component({
    selector: 'ef-contract-management-presenters',
    templateUrl: './contract-management-presenters.component.html',
    styleUrls: ['./contract-management-presenters.component.scss'],
    standalone: false
})
export class ContractManagementPresentersComponent
    implements OnInit, OnDestroy, AfterViewInit
{
    currentSavedContractEndDate: Date;

    SelectedErrorSubject = new ReplaySubject<IStatusMessage>(1);
    private _selectedError: IStatusMessage;
    @Input() public set selectedError(value: IStatusMessage) {
        this.SelectedErrorSubject.next(value);
        if (!value) {
            return;
        }
        if (this._selectedError && this._selectedError.MsgEntityID) {
            const oldRow = document.getElementById(
                `row-${this._selectedError.MsgEntityID.toString()}`
            );
            if (oldRow) {
                oldRow.classList.remove('highlight');
                oldRow.classList.remove('highlight-warning');
                oldRow.classList.remove('highlight-danger');
            }
        }
        this._selectedError = value;
        if (!(value && value.MsgEntityID)) {
            return;
        }
        const row = document.getElementById(
            `row-${value.MsgEntityID.toString()}`
        );
        if (!row) {
            return;
        }
        row.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        // const rows = document.getElementsByClassName('p-selectable-row');
        // if (rows.length > 0) {
        //     rows[0].classList.remove('p-highlight');
        //     rows[0].classList.remove('highlight');
        // }

        //row.classList.remove('p-highlight');
        //row.classList.remove('highlight');
        if (value.StatusCode === ResponseStatus.Warning) {
            row.classList.add('highlight-warning');
        }
        if (value.StatusCode === ResponseStatus.Failed) {
            row.classList.add('highlight-danger');
        }
    }
    public get selectedError(): IStatusMessage {
        return this._selectedError;
    }
    @Input() set contracts(value: Array<IContractManagement>) {
        if (value && value.length > 0) {
            value.forEach(c => {
                if (c.InvoiceCycle != null) {
                    if (c.InvoiceCycle.toString() === '24') {
                        this.hasInvoiceCycle24 = true;
                        this.invoicingColSpan = 6;
                    } else {
                        if (this.hasInvoiceCycle24 === false) {
                            this.invoicingColSpan = 5;
                        }
                    }
                }
                if (c.ContractStartDate != null) {
                    c.ContractStartDate = new Date(c.ContractStartDate);
                }
                if (c.ContractEndDate != null) {
                    c.ContractEndDate = new Date(c.ContractEndDate);
                }
                if (c.CycleEffectiveDate != null) {
                    c.CycleEffectiveDate = new Date(c.CycleEffectiveDate);
                }
                this.effectiveDatesSelectItem.push({
                    value: c.CycleEffectiveDate,
                    label: moment(c.CycleEffectiveDate).format('MM/DD/YYYY')
                });
                this.effectiveDatesSelectItem =
                    this.effectiveDatesSelectItem.filter(
                        (v, i, a) => a.findIndex(t => t.label === v.label) === i
                    );

                if (c.InvoiceCycle != null) {
                    this.icSelectItem.push({
                        value: c.InvoiceCycle,
                        label: c.InvoiceCycle
                    });
                    this.icSelectItem = this.icSelectItem.filter(
                        (v, i, a) => a.findIndex(t => t.label === v.label) === i
                    );
                }

                if (c.InvoiceCycleDay != null) {
                    const day = this.invoiceCycle.find(
                        x =>
                            x.CycleDayCode === c.InvoiceCycleDay &&
                            x.InvoiceCycle === c.InvoiceCycle
                    );
                    this.icdSelectItem.push({
                        value: c.InvoiceCycleDay,
                        label: day ? day.InvoiceCycleDay : c.InvoiceCycleDay
                    });
                    this.icdSelectItem = this.icdSelectItem.filter(
                        (v, i, a) => a.findIndex(t => t.label === v.label) === i
                    );
                }
                if (c.InvoiceCycleDay2 != null) {
                    const day2 = this.invoiceCycle.find(
                        x =>
                            x.CycleDayCode === c.InvoiceCycleDay2 &&
                            x.InvoiceCycle === c.InvoiceCycle
                    );
                    this.icd2SelectItem.push({
                        value: c.InvoiceCycleDay2,
                        label: day2 ? day2.InvoiceCycleDay : c.InvoiceCycleDay2
                    });
                    this.icd2SelectItem = this.icd2SelectItem.filter(
                        (v, i, a) => a.findIndex(t => t.label === v.label) === i
                    );
                }

                if (c.ContractCategory != null) {
                    this.catSelectItem.push({
                        value: c.ContractCategory,
                        label: c.ContractCategory
                    });
                    this.catSelectItem = this.catSelectItem.filter(
                        (v, i, a) => a.findIndex(t => t.label === v.label) === i
                    );
                }

                if (c.ContractListID != null) {
                    this.contractsSelectItem.push({
                        value: c.ContractListID,
                        label: c.ContractDesc
                    });
                    this.contractsSelectItem = this.contractsSelectItem.filter(
                        (v, i, a) => a.findIndex(t => t.label === v.label) === i
                    );
                }
            });

            this._contracts = value;
            this.ContractsSubject.next(value);
            if (this.IsInitialPageLoad === true) {
                if (this._contracts.length > 0) {
                    this.selectedContract = this._contracts[0];
                    this.contractHasBeenSelected();
                    this.IsInitialPageLoad = false;
                }
            }
        }
    }
    get contracts(): Array<IContractManagement> {
        return this._contracts;
    }
    replacementCNs: IChargeNumberManagement[];
    /** Captured before CN save; restored when `[chargeNumbers]` refreshes from the store. */
    private cnScrollTopPendingRestore: number | null = null;
    @Input() set chargeNumbers(value: Array<IChargeNumberManagement>) {
        if (value) {
            this._chargenumbers = value.map(x => ({
                AuthorizedHours: x.AuthorizedHours,
                CNListID: x.CNListID,
                FullName: x.FullName,
                IsActive: x.IsActive,
                FundedAmount: x.FundedAmount,
                FundingAvailable: x.FundingAvailable,
                ContractType: x.ContractType,
                CNStartDate: moment(x.CNStartDate).isValid()
                    ? moment(x.CNStartDate).toDate()
                    : null,
                CNEndDate: moment(x.CNEndDate).isValid()
                    ? moment(x.CNEndDate).toDate()
                    : null,
                FundingSourceCode: x.FundingSourceCode,
                LineItem: x.LineItem,
                InvPrefix: x.InvPrefix,
                BurnRateStartDate: moment(x.BurnRateStartDate).isValid()
                    ? moment(x.BurnRateStartDate).toDate()
                    : null,
                CostCenterID: x.CostCenterID,
                ServiceCenterListID: x.ServiceCenterListID,
                ServiceCenterPercent: x.ServiceCenterPercent,
                RollingCNListID: x.RollingCNListID,
                RollingAuthStartDate: moment(x.RollingAuthStartDate).isValid()
                    ? moment(x.RollingAuthStartDate).toDate()
                    : null,
                RollingAuthEndDate: moment(x.RollingAuthEndDate).isValid()
                    ? moment(x.RollingAuthEndDate).toDate()
                    : null,
                CurrentAuthUser: x.CurrentAuthUser,
                CurrentTM: x.CurrentTM,
                MaxTimeEntered: moment(x.MaxTimeEntered).isValid()
                    ? moment(x.MaxTimeEntered).toDate()
                    : null,
                Status: x.Status,
                Row_Version: x.Row_Version,
                id: x.id
            }));
            // this.cnTableData = this._chargenumbers;
            this.ChargeNumbersSubject.next(this._chargenumbers);
            this.cnSelectItems = this._chargenumbers.map(x => ({
                label: x.FullName,
                value: x.CNListID
            }));
            this.queueCnTableScrollRestore();
        }
    }
    get chargeNumbers(): Array<IChargeNumberManagement> {
        return this._chargenumbers;
    }
    filteredFundingMods: IFundingMod[];
    /** Captured before save; restored when `[fundingMods]` refreshes from the store. */
    private fmScrollTopPendingRestore: number | null = null;

    @Input() set fundingMods(value: Array<IFundingMod>) {
        if (value) {
            let contract;
            let c_index;
            let cn;
            let cn_index;
            let cn2;
            let cn2Index;
            value.forEach(fm => {
                if (fm.FundingModDate != null) {
                    fm.FundingModDate = new Date(fm.FundingModDate);
                }
            if (this.submitted === true) {
                    if (fm.ContractFunding != null) {
                        contract = this.contracts.find(
                            x => x.ContractListID === fm.ContractListID
                        );
                        c_index = this.contracts.findIndex(
                            x => x.ContractListID === fm.ContractListID
                        );
                        if (contract != null) {
                            if (
                                fm.ContractFunding !== contract.ContractFunding
                            ) {
                                this.contracts[c_index].ContractFunding =
                                    fm.ContractFunding;
                                this.ContractsSubject.next(this.contracts);
                            }
                        }
                    }
                    if (fm.CNFundedAmount != null) {
                        cn = this.chargeNumbers.find(
                            x => x.CNListID === fm.CNListID
                        );
                        cn_index = this.chargeNumbers.findIndex(
                            x => x.CNListID === fm.CNListID
                        );
                        if (cn != null) {
                            if (fm.CNFundedAmount !== cn.FundedAmount) {
                                this.chargeNumbers[cn_index].FundedAmount =
                                    fm.CNFundedAmount;
                                this.ChargeNumbersSubject.next(
                                    this.chargeNumbers
                                );
                            }
                        }
                    }
                    if (fm.CNFundingAvailable != null) {
                        cn2 = this.chargeNumbers.find(
                            x => x.CNListID === fm.CNListID
                        );
                        cn2Index = this.chargeNumbers.findIndex(
                            x => x.CNListID === fm.CNListID
                        );
                        if (cn2 != null) {
                            if (
                                fm.CNFundingAvailable !== cn2.FundingAvailable
                            ) {
                                this.chargeNumbers[cn2Index].FundingAvailable =
                                    fm.CNFundingAvailable;
                                this.ChargeNumbersSubject.next(
                                    this.chargeNumbers
                                );
                            }
                        }
                    }
                    this.submitted = false;
                }
            });
            this.sortFundingMods(value);
            this._fundingmods = value;
            this.FundingModsSubject.next(value);
            this.queueFmTableScrollRestore();
        }
    }
    get fundingMods(): Array<IFundingMod> {
        return this._fundingmods;
    }
    @Input() set invoiceCycle(value: Array<IInvoiceCycle>) {
        if (value) {
            this._invoicecycle = value;
            this.InvoiceCycleSubject.next(this._invoicecycle);
            // this.uniqueInvoiceCycles = this._invoicecycle.filter(item => {
            //   var i = this.uniqueInvoiceCycles.findIndex(x => (x.InvoiceCycle === item.InvoiceCycle && x.InvoiceCycleDay === item.InvoiceCycleDay && x.CycleDayCode === item.CycleDayCode));
            //   if (i <= -1) {
            //     this.uniqueInvoiceCycles.push(item);
            //   }
            //   return null;
            // });
            this.uniqueInvoiceCycles = uniqBy(
                this._invoicecycle,
                x => x.InvoiceCycle
            );
            // this.uniqueInvoiceCycles.forEach(cycle => {
            //     if (cycle.InvoiceCycle == 'empty') {
            //         cycle.InvoiceCycle = '0';
            //     }
            // });
            this.u_contractSelectItems = this.uniqueInvoiceCycles.map(x => ({
                label: x.InvoiceCycle == '0' ? '0' : x.InvoiceCycle,
                value: x.InvoiceCycle
            }));

            this.log.verbose('u: ' + this.u_contractSelectItems);
        }
    }
    get invoiceCycle(): Array<IInvoiceCycle> {
        return this._invoicecycle;
    }

    constructor(
        private confirmservice: UnsavedChangesService,
        private log: LoggingService,
        protected cdRef: ChangeDetectorRef
    ) {
        this.moment = moment;
    }

    activeUserAuthCount: number;
    activeTMCount: number;
    rollingCNFullName: string;
    currentCNFullName: string;
    displayWarning = false;
    fundingDetailsColSpan: number;
    private ContractsSubject = new ReplaySubject<Array<IContractManagement>>(1);
    private _contracts: Array<IContractManagement>;
    oldFMAmount: number;
    statusColSpan = 1;

    private ChargeNumbersSubject = new ReplaySubject<
        Array<IChargeNumberManagement>
    >(1);
    private _chargenumbers: Array<IChargeNumberManagement>;

    private FundingModsSubject = new ReplaySubject<Array<IFundingMod>>(1);
    private _fundingmods: Array<IFundingMod>;

    private InvoiceCycleSubject = new ReplaySubject<Array<IInvoiceCycle>>(1);
    private _invoicecycle: Array<IInvoiceCycle>;

    IsInitialPageLoad = true;
    fundingToSubtract = 0;
    invoicingColSpan;
    cntableFrozenColSpan = 1;
    cntableFrozenWidth = '34rem';
    ctableFrozenColSpan = 1;
    ctableFrozenWidth = '34rem';
    fmtableFrozenWidth = '34rem';
    cnCbxValue = false;
    cCbxValue = false;
    space = '';
    replacementCNsSelectItem: SelectItem[];
    cnSelectItems: SelectItem[];
    userGroupSelectItems: SelectItem[];
    contractSelectItems: SelectItem[];
    contractSelectItemsD2: SelectItem[];
    u_contractSelectItems: SelectItem[];
    newFundingMod: Partial<IFundingMod> = {};
    submitted: boolean;
    addNewDialog: boolean;
    moment: any;
    dropdownItemHeight = environment.dropdownItemHeight;
    IsIncludeInactive = false;
    active = true;
    contractSelected = false;
    chargeNumbersSelected = false;
    chargeNumberSelected = false;
    selectedContract: IContractManagement;
    selectedChargeNumbers: Array<IChargeNumberManagement> = [];
    frozenCols: any[];
    cnRowData: IChargeNumberManagement;
    cRowData: IContractManagement;
    scrollableCols: any[];
    cols: any[];
    clonedContracts: { [i: string]: IContractManagement } = {};
    clonedChargeNumbers: { [i: string]: IChargeNumberManagement } = {};
    clonedFundingMods: { [i: string]: IFundingMod } = {};
    uniqueInvoiceCycles: IInvoiceCycle[] = [];
    uniqueInvoiceCycleDays: IInvoiceCycle[] = [];
    costCenterID: any;
    invoiceCycleDays: IInvoiceCycle[];
    invoiceCycleDay2Arr: IInvoiceCycle[];
    selectedInvoiceCycle: number;
    chargeNumberHeader = `Charge Numbers`;
    fundingModHeader = `Funding Modifications`;
    invoiceCycle24Selected = false;
    hasInvoiceCycle24 = false;
    invoiceCycleDay2: string;
    invoiceCycleSelected: any;
    invoiceCycleDaySelected: any;
    invoiceCycleDayHasBeenSelected = false;
    invoiceCycleHasBeenSelected = false;
    numOfRowsEditing = 0;
    displayDatesDialog = false;
    rollingAuthEndDate;
    rollingAuthStartDate;
    rollingCNListID;
    maxTimeEntered;
    ccColumnHidden: boolean;
    errorClicked = false;
    @Output() contractSelectedEvent = new EventEmitter<IContract>();
    @Output() chargeNumbersSelectedEvent = new EventEmitter<IContract>();
    @Output() SaveContract = new ReplaySubject<IContractManagement>(1);
    @Output() SaveChargeNumber = new ReplaySubject<IChargeNumberManagement>(1);
    @Output() SaveFundingMod = new ReplaySubject<Partial<IFundingMod>>(1);
    @Output() DeleteFundingMod = new ReplaySubject<IFundingMod>(1);
    @Output() ToggleInactiveContracts = new ReplaySubject<boolean>(1);
    @Output() ToggleInactiveCNs = new ReplaySubject<IContract>(1);
    @Output() ToggleInactiveFMs = new ReplaySubject<IContract>(1);

    @Output() public ShowError = new EventEmitter<IShowErrors>();

    // @ViewChild('chkShowAllContracts', { static: true })
    // cnCheckbox: Checkbox;

    @ViewChild('dataTable', { static: true }) CTable: Table;
    @ViewChild('CNTable', { static: true }) CNTable: Table;
    @ViewChild('FMTable', { static: true }) FMTable: Table;

    @Input() public userGroups: Array<fromLookups.IUserGroup>;
    @Input() userInfo: IUserInfo;
    cnEditing: IChargeNumberManagement;
    cEditing: IContractManagement;
    fmEditing: IFundingMod;

    endDateTooltip: string;
    effectiveDatesSelectItem: SelectItem[] = [];
    icSelectItem: SelectItem[] = [];
    icdSelectItem: SelectItem[] = [];
    icd2SelectItem: SelectItem[] = [];
    catSelectItem: SelectItem[] = [];
    contractsSelectItem: SelectItem[] = [];

    public currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });

    activeState = [true, true, true];
    cTabHeight: any;
    cnTabHeight: any;
    fmTabHeight: any;

    IsCurrentYearFM = false;

    IsContractLocked = false;
    IsCategoryLocked = false;

    categoryLockIcon = 'pi pi-lock';

    IsColumnFrozen = false;

    getStatusIcon = (a, b) => fromShared.getStatusIcon(a, b);

    toggleLockCategoryColumn(fromEdit, event: MouseEvent) {
        if (event) {
            event.stopPropagation();
        }
        if (fromEdit == true) {
            this.IsCategoryLocked = false;
        } else {
            this.IsCategoryLocked = !this.IsCategoryLocked;
        }

        if (this.categoryLockIcon == 'pi pi-lock') {
            this.categoryLockIcon = 'pi pi-unlock';
        } else {
            this.categoryLockIcon = 'pi pi-lock';
        }
    }

    ngOnInit() {
        if (this.userGroups.length > 0) {
            this.userGroups = this.userGroups.filter(x =>
                x.PrefixedGroupID.includes('C')
            );
            this.userGroupSelectItems = this.userGroups.map(x => ({
                label: x.GroupName,
                value: x.GroupID
            }));
            this.userGroupSelectItems.unshift({
                label: '',
                value: 0
            });

            if (this.userGroups.length > 1) {
                this.fundingDetailsColSpan = 10;
                this.ccColumnHidden = false;
            } else {
                this.fundingDetailsColSpan = 9;
                this.ccColumnHidden = true;
            }
        }

        this.handleOnOpen([0, 1, 2]);
    }

    ngAfterViewInit() {
        this.IsColumnFrozen = true;
    }

    ngOnDestroy() {
        this.active = false;
    }

    currentYearCheckboxChanged($event) {
        if ($event.checked == true) {
            const currentYear = moment().year();
            this.filteredFundingMods = this.fundingMods.filter(x => {
                return (
                    x.FundingModDate >= new Date(`01/01/${currentYear}`) &&
                    x.FundingModDate <= new Date(`12/31/${currentYear}`)
                );
            });
            this.FundingModsSubject.next(this.filteredFundingMods);
            this.FMTable.value = this.filteredFundingMods;
        }
        if ($event.checked == false) {
            this.FundingModsSubject.next(this.fundingMods);
            this.FMTable.value = this.fundingMods;
        }
    }

    sortFundingMods(array: Array<any>) {
        array.sort((a, b) => {
            if (a.FullName === b.FullName) {
                return 0;
            }
            if (typeof a.FullName === typeof b.FullName) {
                return a.FullName < b.FullName ? -1 : 1;
            }
            return typeof a.FullName < typeof b.FullName ? -1 : 1;
        });
    }

    trackByFundingModRow(_index: number, row: IFundingMod): number {
        return row.FundingID;
    }

    trackByChargeNumberRow(
        _index: number,
        row: IChargeNumberManagement
    ): number | string {
        return row.CNListID;
    }

    private getCnTableBodyScrollTop(): number {
        const el = this.CNTable?.wrapperViewChild?.nativeElement;
        return el ? el.scrollTop : 0;
    }

    private queueCnTableScrollRestore(): void {
        if (this.cnScrollTopPendingRestore == null) {
            return;
        }
        const top = this.cnScrollTopPendingRestore;
        this.cnScrollTopPendingRestore = null;
        Promise.resolve().then(() => {
            requestAnimationFrame(() => {
                this.CNTable?.scrollTo({ top });
            });
        });
    }

    private getFmTableBodyScrollTop(): number {
        const el = this.FMTable?.wrapperViewChild?.nativeElement;
        return el ? el.scrollTop : 0;
    }

    private queueFmTableScrollRestore(): void {
        if (this.fmScrollTopPendingRestore == null) {
            return;
        }
        const top = this.fmScrollTopPendingRestore;
        this.fmScrollTopPendingRestore = null;
        Promise.resolve().then(() => {
            requestAnimationFrame(() => {
                this.FMTable?.scrollTo({ top });
            });
        });
    }

    unique(obj, prop) {
        const result = [];
        const seen = new Set();

        Object.keys(obj).forEach(key => {
            const value = obj[key];
            const test = !prop ? value : value[prop];

            if (!seen.has(test)) {
                seen.add(test);
                result.push(value);
            }
        });

        return result;
    }
    tableFilter($event, type) {
        if (type == 'effectiveDate') {
            this.CTable.filter($event.value, 'CycleEffectiveDate', 'in');
        }
        if (type == 'ic') {
            this.CTable.filter($event.value, 'InvoiceCycle', 'in');
        }
        if (type == 'icd') {
            this.CTable.filter($event.value, 'InvoiceCycleDay', 'in');
        }
        if (type == 'icd2') {
            this.CTable.filter($event.value, 'InvoiceCycleDay2', 'in');
        }
        if (type == 'cat') {
            this.CTable.filter($event.value, 'ContractCategory', 'in');
        }
        if (type == 'contract') {
            this.CTable.filter($event.value, 'ContractListID', 'in');
            if (
                $event.value.some(
                    x => x == this.selectedContract.ContractListID
                ) == true
            ) {
                this.log.verbose('Do not clear');
            } else {
                this.selectedContract = this.contracts.find(
                    x => x.ContractListID == $event.value[0]
                );
                this.contractHasBeenSelected();
            }
        }
    }
    setupSubscriptions() {
        this.ContractsSubject.pipe(takeWhile(() => this.active)).subscribe(
            contracts => {
                if (this.IsIncludeInactive === true) {
                    // Show unfiltered data
                } else {
                    this.contracts = contracts.filter(
                        contract => contract.IsActive === true
                    );
                }
            }
        );
    }

    // ------------------------------CHARGE NUMBER TABLE FUNCTIONS-------------------------
    onRowEditInit(rowData: IChargeNumberManagement) {
        this.clonedChargeNumbers[rowData.CNListID] = { ...rowData };
        this.cnEditing = { ...rowData };
        this.log.verbose('[DEBUG] onRowEditInit: cnEditing set to', this.cnEditing);
        this.rollingAuthStartDate =
            this.clonedChargeNumbers[rowData.CNListID].RollingAuthStartDate;
        this.rollingAuthEndDate =
            this.clonedChargeNumbers[rowData.CNListID].RollingAuthEndDate;
        this.maxTimeEntered = moment(this.clonedChargeNumbers[rowData.CNListID].MaxTimeEntered).isValid() ? moment(
            this.clonedChargeNumbers[rowData.CNListID].MaxTimeEntered
        ).format('MM/DD/YYYY') : 'N/A';

        this.replacementCNs = this.chargeNumbers.filter(
            x => x.CNListID != rowData.CNListID
        );
        this.replacementCNsSelectItem = this.replacementCNs.map(x => ({
            label: x.FullName,
            value: x.CNListID
        }));
        this.log.verbose('onRowEditInit');
    }

    onRowEditSave(rowData: IChargeNumberManagement) {
        // if (this.costCenterID != null) {
        //     rowData.CostCenterID = this.costCenterID.GroupID;
        // }
        if (
            rowData.RollingCNListID !==
            this.clonedChargeNumbers[rowData.CNListID].RollingCNListID
        ) {
            this.displayWarning = false;
            this.activeTMCount = rowData.CurrentTM;
            this.activeUserAuthCount = rowData.CurrentAuthUser;
            this.rollingCNListID = rowData.RollingCNListID;
            const rollingCN = this.chargeNumbers.find(
                x => x.CNListID === this.rollingCNListID
            );
            this.rollingCNFullName = rollingCN.FullName;
            this.currentCNFullName = rowData.FullName;
            if (rollingCN.CNStartDate != null) {
                this.rollingAuthStartDate = rollingCN.CNStartDate;
            } else {
                this.rollingAuthStartDate = new Date();
            }
            if (rollingCN.CNEndDate != null) {
                this.rollingAuthEndDate = rollingCN.CNEndDate;
            }

            this.displayDatesDialog = true;
            this.clonedChargeNumbers[rowData.CNListID] = { ...rowData };
        } else {
            this.cnScrollTopPendingRestore = this.getCnTableBodyScrollTop();
            this.SaveChargeNumber.next(rowData);
            delete this.clonedChargeNumbers[rowData.CNListID];
            delete this.cnEditing;
        }

        this.log.verbose('onRowEditSave');
    }

    onRowEditCancel(item: IChargeNumberManagement) {
        const index = this.chargeNumbers.findIndex(
            x => x.CNListID === item.CNListID
        );
        if (index >= 0) {
            this.chargeNumbers.splice(
                index,
                1,
                this.clonedChargeNumbers[item.CNListID]
            );
        }
        this.chargeNumbers = [...this.chargeNumbers];

        delete this.clonedChargeNumbers[item.CNListID];
        this.log.verbose('[DEBUG] onRowEditCancel: deleting cnEditing (was)', this.cnEditing);
        delete this.cnEditing;
        // Force PrimeNG table to exit edit mode for this row
        if (this.CNTable && this.CNTable.editingRowKeys) {
            this.CNTable.editingRowKeys[item.CNListID] = false;
        }
        this.cdRef.detectChanges();
        this.log.verbose('onRowEditCancel');
    }

    onAuthStartDateSelected(value) {}

    onAuthEndDateSelected(value) {}

    confirmBtnClickedDateDialog() {
        if (this.rollingAuthEndDate > this.rollingAuthStartDate) {
            this.displayWarning = false;
            this.clonedChargeNumbers[
                this.cnEditing.CNListID
            ].RollingAuthStartDate = this.rollingAuthStartDate;
            this.clonedChargeNumbers[
                this.cnEditing.CNListID
            ].RollingAuthEndDate = this.rollingAuthEndDate;
            this.cnScrollTopPendingRestore = this.getCnTableBodyScrollTop();
            this.SaveChargeNumber.next(
                this.clonedChargeNumbers[this.cnEditing.CNListID]
            );
            delete this.clonedChargeNumbers[this.cnEditing.CNListID];
            delete this.cnEditing;
            this.displayDatesDialog = false;
        } else {
            this.displayWarning = true;
        }
    }

    cancelBtnClickedDateDialog() {
        const index = this.chargeNumbers.findIndex(
            x => x.CNListID === this.cnEditing.CNListID
        );
        this.chargeNumbers.splice(index, 1, this.cnEditing);
        delete this.clonedChargeNumbers[this.cnEditing.CNListID];
        delete this.cnEditing;
        this.displayDatesDialog = false;
    }

    onCNStartDateSelected(value) {
        this.log.verbose(
            `CNStartDateSelected: ${moment(value).format('MM/DD/YYYY')}`
        );
    }

    onCNEndDateSelected(value) {
        this.log.verbose('CNEndDateSelected');
    }

    onBurnStartDateSelected(value) {
        this.log.verbose('BurnStartDateSelected');
    }

    onChargeNumbersSelected(value) {
        this.chargeNumbersSelected = true;
        this.log.verbose(this.selectedChargeNumbers);
        this.chargeNumbersSelectedEvent.emit(value.data);
    }

    costCenterValueChanged(event) {
        this.costCenterID = event.value;
    }

    findCostCenterName(rowData: IChargeNumberManagement): string {
        if (rowData.CostCenterID != null) {
            if (rowData.CostCenterID === 0) {
                return '';
            } else {
                const cc = this.userGroups.find(
                    x => x.GroupID === rowData.CostCenterID
                );
                return cc.GroupName;
            }
        } else {
            return '';
        }
    }

    findCNFullName(rowData: IChargeNumberManagement): string {
        if (rowData.RollingCNListID != null) {
            if (rowData.RollingCNListID === '') {
                return '';
            } else {
                const cn = this.chargeNumbers.find(
                    x => x.CNListID === rowData.RollingCNListID
                );
                if (cn != null) {
                    return cn.FullName;
                } else {
                    return '';
                }
            }
        } else {
            return '';
        }
    }

    showAllCNsChecked(event) {
        if (event.checked === true) {
            this.statusColSpan = 2;
            this.cntableFrozenColSpan = 2;
            this.cntableFrozenWidth = '38rem';
        } else {
            this.cntableFrozenColSpan = 1;
            this.statusColSpan = 1;
            this.cntableFrozenWidth = '34rem';
        }
        this.ToggleInactiveFMs.next({
            ContractListID: this.selectedContract.ContractListID,
            Activeonly: !event.checked
        });
        this.ToggleInactiveCNs.next({
            ContractListID: this.selectedContract.ContractListID,
            Activeonly: !event.checked
        });
    }

    lessThanToday(endDate) {
        if (moment(endDate).toDate() < new Date()) {
            this.endDateTooltip = 'Invoicing not scheduled after Contract End';
            return true;
        } else {
            this.endDateTooltip = '';
            return false;
        }
    }

    // -------------------------CONTRACT TABLE FUNCTIONS----------------------------------
    onContractRowEditInit(rowData: IContractManagement) {
        if (rowData.InvoiceCycle != null) {
            this.invoiceCycleDays = this.invoiceCycle.filter(
                x => x.InvoiceCycle === rowData.InvoiceCycle
            );
            this.contractSelectItems = this.invoiceCycleDays.map(x => ({
                label: x.InvoiceCycleDay,
                value: x.CycleDayCode
            }));
        }
        if (this.hasInvoiceCycle24 === true) {
        }
        if (rowData.ContractEndDate != null) {
            this.currentSavedContractEndDate = rowData.ContractEndDate;
        }
        this.clonedContracts[rowData.ContractListID] = { ...rowData };
        this.cEditing = { ...rowData };
        this.invoiceCycle24Selected = false;
        this.log.verbose('onRowEditInit');
        this.IsContractLocked = true;
    }

    onContractRowEditSave(rowData: IContractManagement) {
        if (this.invoiceCycleHasBeenSelected === true) {
            // rowData.InvoiceCycle = this.invoiceCycleSelected;
            if (rowData.InvoiceCycle.toString() === '24') {
                rowData.InvoiceCycleDay2 = '99';
                rowData.InvoiceCycleDay = '15';
            } else {
                rowData.InvoiceCycleDay2 = '';
            }
        }
        // if (this.invoiceCycleDayHasBeenSelected) {
        //     rowData.InvoiceCycleDay = this.invoiceCycleDaySelected.CycleDayCode;
        // }
        this.SaveContract.next(rowData);
        delete this.clonedContracts[rowData.ContractListID];
        delete this.cEditing;
        this.invoiceCycleHasBeenSelected = false;
        this.invoiceCycleDayHasBeenSelected = false;
        this.invoiceCycle24Selected = false;
        this.log.verbose('onRowEditSave' + rowData);
        this.IsContractLocked = false;
        this.toggleLockCategoryColumn(true, null);
    }

    onContractRowEditCancel(rowData: IContractManagement, index: number) {
        this.contracts.splice(
            index,
            1,
            this.clonedContracts[rowData.ContractListID]
        );
        delete this.clonedContracts[rowData.ContractListID];
        delete this.cEditing;
        this.invoiceCycle24Selected = false;
        this.log.verbose('onRowEditCancel ' + index);
        this.IsContractLocked = false;
        this.toggleLockCategoryColumn(true, null);
    }

    statusCellClicked() {
        this.errorClicked = true;
    }

    onContractSelected(value) {
        if (this.errorClicked == true) {
            this.errorClicked = false;
        } else {
            this.cnScrollTopPendingRestore = null;
            this.fmScrollTopPendingRestore = null;
            this.log.verbose('[DEBUG] onContractSelected: cnEditing is', this.cnEditing);
            // Cancel CN editing if needed
            if (this.cnEditing) {
                const cnIndex = this.chargeNumbers.findIndex(x => x.CNListID === this.cnEditing.CNListID);
                this.log.verbose('[DEBUG] onContractSelected: found cnEditing, cnIndex', cnIndex);
                if (cnIndex !== -1) {
                    this.onRowEditCancel(this.cnEditing);
                }
            }
            // Cancel FM editing if needed
            this.log.verbose('[DEBUG] onContractSelected: fmEditing is', this.fmEditing);
            if (this.fmEditing) {
                const fmIndex = this.fundingMods.findIndex(x => x.FundingID === this.fmEditing.FundingID);
                this.log.verbose('[DEBUG] onContractSelected: found fmEditing, fmIndex', fmIndex);
                if (fmIndex !== -1) {
                    this.onFMRowEditCancel(this.fmEditing, fmIndex);
                }
            }
            // Also clear all editingRowKeys for CNTable and FMTable to ensure UI is not stuck in edit mode
            if (this.CNTable && this.CNTable.editingRowKeys) {
                Object.keys(this.CNTable.editingRowKeys).forEach(key => {
                    this.CNTable.editingRowKeys[key] = false;
                });
            }
            if (this.FMTable && this.FMTable.editingRowKeys) {
                Object.keys(this.FMTable.editingRowKeys).forEach(key => {
                    this.FMTable.editingRowKeys[key] = false;
                });
            }
            this.cdRef.detectChanges();
            this.contractHasBeenSelected();
        }
    }

    contractHasBeenSelected() {
        // const rows = document.getElementsByClassName('p-selectable-row');
        // if (rows.length > 0) {
        //     rows[0].classList.remove('p-highlight');
        //     rows[0].classList.remove('highlight');
        // }
        this.chargeNumberHeader =
            this.selectedContract.ContractDesc + '\xa0\xa0' + 'Charge Numbers';
        this.fundingModHeader =
            this.selectedContract.ContractDesc +
            '\xa0\xa0' +
            'Funding Modifications';
        this.contractSelected = true;
        // const contract = {
        //     ContractListID: value.data.ContractListID,
        //     Activeonly: true
        // };
        const contract = {
            ContractListID: this.selectedContract.ContractListID,
            Activeonly: true
        };
        this.cnCbxValue = false;
        this.contractSelectedEvent.emit(contract);
        this.chargeNumbersSelectedEvent.emit(contract);
    }

    onCycleEffectiveDateSelected(value) {
        this.log.verbose('EffectiveDateSelected');
    }

    onContractEndDateSelected(value, rowData) {
        if (this.userInfo) {
            if (this.currentSavedContractEndDate < this.userInfo.FYStartDate) {
                this.confirmservice
                    .confirmPromise({
                        dialogText:
                            'This will update a contract that had previously expired. Please update invoice schedule in eFAACT Central-Invoice Schedules.',
                        okText: 'OK',
                        cancelText: 'Cancel'
                    })
                    .then(() => {})
                    .catch(() => {
                        rowData.ContractEndDate =
                            this.currentSavedContractEndDate;
                    });
            }
        }
        this.log.verbose('EndDateSelected');
    }

    onContractStartDateSelected(value) {
        this.log.verbose('StartDateSelected');
    }

    invoiceCycleValueChanged(event) {
        this.invoiceCycleHasBeenSelected = true;
        if (event.value === 24) {
            this.invoiceCycle24Selected = true;

            // this.invoiceCycleDays = [{
            //   InvoiceCycle: 24,
            //   InvoiceCycleDay: "15"
            // }];

            // this.invoiceCycleDay2Arr = [{
            //   InvoiceCycle: 24,
            //   InvoiceCycleDay: "EOM"
            // }];
            this.invoiceCycleDays = this.invoiceCycle.filter(
                x => x.InvoiceCycle === event.value
            );
            this.contractSelectItems = this.invoiceCycleDays.map(x => ({
                label: x.InvoiceCycleDay,
                value: x.CycleDayCode
            }));
            this.contractSelectItemsD2 = this.invoiceCycleDays.map(x => ({
                label: x.InvoiceCycleDay,
                value: x.CycleDayCode
            }));

            if (
                JSON.stringify(this.contractSelectItems.sort()) ===
                JSON.stringify(this.contractSelectItemsD2.sort())
            ) {
                this.contractSelectItemsD2 = this.contractSelectItemsD2.filter(
                    x => x.value !== '15'
                );
                this.contractSelectItems = this.contractSelectItems.filter(
                    x => x.value !== '99'
                );
            }
        } else {
            this.invoiceCycle24Selected = false;
            this.invoiceCycleDays = this.invoiceCycle.filter(
                x => x.InvoiceCycle === event.value
            );
            this.contractSelectItems = this.invoiceCycleDays.map(x => ({
                label: x.InvoiceCycleDay,
                value: x.CycleDayCode
            }));
        }
        this.invoiceCycleSelected = event.value;
    }

    invoiceCycleDayValueChanged(event) {
        this.invoiceCycleDayHasBeenSelected = true;
        this.invoiceCycleDaySelected = event.value;
    }

    invoiceCycleDay2ValueChanged(event) {}

    showAllContractsChecked(event) {
        if (event.checked === true) {
            this.ctableFrozenColSpan = 2;
            this.ctableFrozenWidth = '38rem';
            this.invoicingColSpan = 6;
        } else {
            this.invoicingColSpan = 5;
            this.ctableFrozenColSpan = 1;
            this.ctableFrozenWidth = '34rem';
        }
        this.ToggleInactiveContracts.next(!event.checked);
    }

    findInvoiceDayDesc(rowData: IContractManagement): string {
        if (rowData.InvoiceCycleDay != null) {
            if (this.invoiceCycle.length > 0) {
                const index = this.invoiceCycle.findIndex(
                    x =>
                        x.CycleDayCode === rowData.InvoiceCycleDay &&
                        x.InvoiceCycle === rowData.InvoiceCycle
                );
                if (index !== -1) {
                    const cc = this.invoiceCycle[index];
                    return cc.InvoiceCycleDay;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    }

    findInvoiceDay2Desc(rowData: IContractManagement): string {
        if (rowData.InvoiceCycleDay2 != null) {
            if (this.invoiceCycle.length > 0) {
                const index = this.invoiceCycle.findIndex(
                    x =>
                        x.CycleDayCode === rowData.InvoiceCycleDay2 &&
                        x.InvoiceCycle === rowData.InvoiceCycle
                );
                if (index !== -1) {
                    const cc = this.invoiceCycle[index];
                    return cc.InvoiceCycleDay;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    }

    onStatusClick(item: IContractManagement) {
        this.ShowError.emit({ open: true, MsgEntityID: item.ContractListID });
    }

    // ----------------------FUNDING MOD FUNCTIONS------------------------------
    onFMRowEditInit(rowData: IFundingMod) {
        const fmindex = this.fundingMods.findIndex(
            x => x.FundingID === rowData.FundingID
        );
        this.oldFMAmount = +this.fundingMods[fmindex].FundingModAmount;
        this.clonedFundingMods[rowData.CNListID] = { ...rowData };
        this.fmEditing = { ...rowData };
        this.log.verbose('onRowEditInit');
    }

    onFMRowEditSave(rowData: IFundingMod) {
        this.fmScrollTopPendingRestore = this.getFmTableBodyScrollTop();
        this.performFundingCalc(rowData);
        this.SaveFundingMod.next(rowData);
        delete this.clonedFundingMods[rowData.CNListID];
        delete this.fmEditing;
        this.log.verbose('onRowEditSave' + rowData);
    }

    onFMRowEditCancel(rowData: IFundingMod, index: number) {
        this.fundingMods.splice(
            index,
            1,
            this.clonedFundingMods[rowData.CNListID]
        );
        delete this.clonedFundingMods[rowData.CNListID];
        delete this.fmEditing;
        this.log.verbose('onRowEditCancel' + index);
    }

    performFundingCalc(rowData) {
        const cindex = this.contracts.findIndex(
            x => x.ContractListID === rowData.ContractListID
        );
        const cnindex = this.chargeNumbers.findIndex(
            x => x.CNListID === rowData.CNListID
        );
        if (+rowData.FundingModAmount >= this.oldFMAmount) {
            this.fundingToSubtract =
                +rowData.FundingModAmount - this.oldFMAmount;
            this.contracts[cindex].ContractFunding = (
                +this.contracts[cindex].ContractFunding + this.fundingToSubtract
            ).toString();
            this.ContractsSubject.next(this.contracts);
            this.chargeNumbers[cnindex].FundedAmount = (
                +this.chargeNumbers[cnindex].FundedAmount +
                this.fundingToSubtract
            ).toString();
            this.chargeNumbers[cnindex].FundingAvailable = (
                +this.chargeNumbers[cnindex].FundingAvailable +
                this.fundingToSubtract
            ).toString();
            this.ChargeNumbersSubject.next(this.chargeNumbers);
        } else {
            this.fundingToSubtract =
                this.oldFMAmount - +rowData.FundingModAmount;
            this.contracts[cindex].ContractFunding = (
                +this.contracts[cindex].ContractFunding - this.fundingToSubtract
            ).toString();
            this.ContractsSubject.next(this.contracts);
            this.chargeNumbers[cnindex].FundedAmount = (
                +this.chargeNumbers[cnindex].FundedAmount -
                this.fundingToSubtract
            ).toString();
            this.chargeNumbers[cnindex].FundingAvailable = (
                +this.chargeNumbers[cnindex].FundingAvailable -
                this.fundingToSubtract
            ).toString();
            this.ChargeNumbersSubject.next(this.chargeNumbers);
        }
    }

    onFundingModDateSelected(value) {
        this.log.verbose(
            `FundingModDateSelected: ${moment(value).format('MM/DD/YYYY')}`
        );
    }

    addNewCNValueChanged(event) {
        // this.newFundingMod.FullName = event.value.FullName;
        // this.newFundingMod.CNListID = event.value.CNListID;
    }

    onFundingModDelete(rowData) {
        this.confirmservice
            .confirmPromise({
                dialogText:
                    'Are you sure you want to delete this funding modification?',
                okText: 'OK',
                cancelText: 'Cancel'
            })
            .then(() => {
                this.fundingToSubtract = +rowData.FundingModAmount;
                const cindex = this.contracts.findIndex(
                    x => x.ContractListID === rowData.ContractListID
                );
                const cnindex = this.chargeNumbers.findIndex(
                    x => x.CNListID === rowData.CNListID
                );
                this.contracts[cindex].ContractFunding = (
                    +this.contracts[cindex].ContractFunding -
                    this.fundingToSubtract
                ).toString();
                this.ContractsSubject.next(this.contracts);
                this.chargeNumbers[cnindex].FundedAmount = (
                    +this.chargeNumbers[cnindex].FundedAmount -
                    this.fundingToSubtract
                ).toString();
                this.chargeNumbers[cnindex].FundingAvailable = (
                    +this.chargeNumbers[cnindex].FundingAvailable -
                    this.fundingToSubtract
                ).toString();
                this.ChargeNumbersSubject.next(this.chargeNumbers);
                this.DeleteFundingMod.next(rowData);
            })
            .catch(() => {});
    }

    openNew() {
        this.newFundingMod = {};
        this.submitted = false;
        this.addNewDialog = true;
    }

    hideDialog() {
        this.addNewDialog = false;
        this.submitted = false;
    }
    saveNewMod() {
        this.submitted = true;
        const cn = this.chargeNumbers.find(
            x => x.CNListID === this.newFundingMod.CNListID
        );
        if (
            this.newFundingMod.CNListID &&
            this.newFundingMod.FundingModNbr.trim() &&
            this.newFundingMod.FundingModDate &&
            this.newFundingMod.FundingModAmount.trim()
        ) {
            this.newFundingMod.FullName = cn.FullName;
            this.newFundingMod.FundingID = -1;
            this.newFundingMod.DateUpdated = null;
            this.newFundingMod.CNFundedAmount = null;
            this.newFundingMod.ContractListID = null;
            this.newFundingMod.ContractFunding = null;
            this.newFundingMod.Status = {
                StatusCode: 0,
                Message: null,
                MsgProcessID: 0,
                MsgEntityID: null
            };
            this.newFundingMod.Row_Version = '0x0000000000000000';
            if (this.selectedContract?.ContractListID) {
                this.newFundingMod.ContractListID =
                    this.selectedContract.ContractListID;
            }
            this.fmScrollTopPendingRestore = this.getFmTableBodyScrollTop();
            this.SaveFundingMod.next(this.newFundingMod);
            this.fundingMods = [...this.fundingMods];
            this.addNewDialog = false;
            this.newFundingMod = {};
            this.newFundingMod.FullName = null;
            this.newFundingMod.CNListID = null;
        }
    }

    handleOnOpen($event) {
        const baseHeight = '18vh';
        let accHeight = 0;
        if ($event.length === 1) {
            accHeight += 38;
        } else if ($event.length === 2) {
            accHeight += 10;
        } else {
            accHeight += 0;
        }

        if (this.activeState[0]) {
            this.cTabHeight = `calc(${baseHeight} + ${accHeight}vh)`;
        }
        if (this.activeState[1]) {
            this.cnTabHeight = `calc(${baseHeight} + ${accHeight}vh)`;
        }
        if (this.activeState[2]) {
            this.fmTabHeight = `calc(${baseHeight} + ${accHeight}vh)`;
        }
        // this.CTable.scrollHeight = `calc(${baseHeight} + ${accHeight}em)`;
        this.log.verbose({
            type: 'ContractManagementComponent:handleOnOpen',
            $event,
            scrollHeight: this.CTable.scrollHeight
        });
        this.cdRef.detectChanges();
    }

    onSelectedChargeNumberTab($event) {
        if ($event === true) {
            // this.activeState[1] = true;
            const event = [];
            if (this.activeState[0]) {
                event.push(0);
            }
            if (this.activeState[1]) {
                event.push(1);
            }
            if (this.activeState[2]) {
                event.push(2);
            }
            setTimeout(() => {
                this.handleOnOpen(event);
            }, 0);
        }
    }
}

export interface IContract {
    ContractListID: string;
    Activeonly: boolean;
}
